export default () => ([
    {
      name: '№',
      key: 'id',
      show: true,
      edit: true,
      custom: false,
      disabled_show: true,
      disabled_edit: true
    },
    {
      name: 'Артикул',
      key: 'article',
      show: true,
      edit: true,
      custom: false,
      disabled_show: false,
      disabled_edit: true
    },
    {
      name: 'Код',
      key: 'code',
      show: false,
      edit: false,
      custom: false,
      disabled_show: false,
      disabled_edit: true
    },
    {
      name: 'Наименование',
      key: 'name',
      show: true,
      edit: true,
      custom: false,
      disabled_show: true,
      disabled_edit: true
    },
    {
      name: 'Кол-во',
      key: 'count',
      show: true,
      edit: true,
      custom: false,
      disabled_show: false,
      disabled_edit: false
    },
    {
      name: 'Единица измерения',
      key: 'unit',
      show: true,
      edit: true,
      custom: false,
      disabled_show: false,
      disabled_edit: false
    },
    {
      name: 'Цена',
      key: 'price',
      show: true,
      edit: true,
      custom: false,
      disabled_show: false,
      disabled_edit: false
    },
    {
      name: 'Скидка',
      key: 'discount',
      show: true,
      edit: true,
      custom: false,
      disabled_show: false,
      disabled_edit: false
    },
    {
      name: 'НДС',
      key: 'vat',
      show: true,
      edit: true,
      custom: false,
      disabled_show: false,
      disabled_edit: false
    },
    {
      name: 'Сумма',
      key: 'sum',
      show: true,
      edit: true,
      custom: false,
      disabled_show: true,
      disabled_edit: true
    }
  ])